import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import FeaturedPanel, { FeaturedPanelProps } from './FeaturedPanel';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';

interface FeaturedPanelsProps extends Blok {
  featured_panels: FeaturedPanelProps[];
}

interface FeaturedPanelsBlokProps {
  blok: FeaturedPanelsProps;
}

const FeaturedPanels: React.FC<FeaturedPanelsBlokProps> = ({
  blok: { featured_panels },
}) => {
  return (
    <>
      {featured_panels && (
        <Grid gapX="gap-x-0" gapY="gap-y-0">
          {featured_panels.map((featured_panel: FeaturedPanelProps) => (
            <Col key={featured_panel._uid} span={{ lg: 4 }}>
              <FeaturedPanel blok={featured_panel} />
            </Col>
          ))}
        </Grid>
      )}
    </>
  );
};

export default memo(withBlokWrapper(FeaturedPanels, Theme.DARK));
